// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsent_root__OOT4D"};